import { render, staticRenderFns } from "./diceApp.vue?vue&type=template&id=a47f78f6&"
import script from "./diceApp.vue?vue&type=script&lang=js&"
export * from "./diceApp.vue?vue&type=script&lang=js&"
import style0 from "./diceApp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "diceApp.vue"
export default component.exports